import User from "admin/types/interfaces/user";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_ACCESS_CONTROLLER_API } = import.meta.env;

const useGroupUsers = ({
  groupName,
  activeOnly = true,
}: {
  groupName: string;
  activeOnly?: boolean;
}) => {
  return useFetcher<User[]>(
    `${VITE_ACCESS_CONTROLLER_API}/user-tags/${groupName}/users?active_only=${activeOnly}`
  );
};

export default useGroupUsers;
